import { createAsyncSliceWithData } from '../createAsyncSliceWithData';
import { getAllLendersAsync } from 'API/lenders/LendersAPI';

export const { slice: lendersSlice, asyncAction: getAllLendersAsyncAction } = createAsyncSliceWithData(
  'lenders',
  getAllLendersAsync,
  []
);
